// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8396) return "static/chunks/8396-d4ccde0bcb263259.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5457 ? "a17c4ccd" : chunkId) + "." + {"55":"17ecae3678f7f9cb","529":"9cedd75d0ce7d3eb","956":"aaa7e36fc46d56e6","4384":"d8815890aa4fb204","5457":"affc2e1ed2f651eb","6808":"605f1b562a2db522","8229":"a14b788a390003cf"}[chunkId] + ".js";
};